
import React from "react";
import "./Home.css"; 



//import MyImage from "./assets/supreme-court-of-india.jpg"; 

function About() {
  return <div>
     <img src="/aboutus.jpg" alt="Header" />
  
    <div className="statement" style={{ textAlign: "justify", padding: "0 20px" }}> 
      <p>Legal Experts India is a full service law firm with offices in New Delhi, Mumbai, Bangalore, Chennai, Hyderabad and Pune. We are a team of highly skilled and experienced advocates who are dedicated to providing our clients with the best legal representation possible. We have a proven track record of success in a wide range of legal matters, including personal injury claims, business litigation, and civil rights cases.</p>
    <p>If you want a law firm with cartoonish television ads, we are not for you. 
      If you want a law firm that takes every single case, whether it has merit or not, 
      and try to get a quick, pennies on the Rupees settlement, we not for you. 
      If you want a law firm who will go to the mat fighting for you with professionalism 
      and commitment to your case, we are for you. Our top rated firm does not take every case 
      and client that comes through our doors or is referred to us from other advocates. 
      We screen each and every case before we agree to come on board. But let there be no mistake, 
      if we partner with you in your case, you can rest assured the advocate and staff of legal 
      group will be working hard on your case.</p>
  
  <p>We recognize that your legal problem is not about us, it is about you and your loved ones, 
    and each case is different and demands new strategies and tactics. We will provide you with 
    legal advice and recommendations based on an honest assessment of your case.

Whether yours is a personal injury claim, service or civil matter we are your voice at the 
negotiating table and in the courtroom. We are not afraid to go toe-to- toe with big giant 
organisations and corporations who put their profit over your safety. We believe they have a 
responsibility to protect your interest too.

When we take on your case, you become a critical part of our legal system or team. 
Together, we fight for the justice your deserve,. Form preparing and filing your claim or 
grievance to presenting your lawsuit aggressively and bringing it to verdict or settlement.

To us, every case is personal. Every client benefits from the full measure of our experience and resources.

We truly aim to make a difference in the lives of our clients.

The firm’s ability to enter into different forms of contingent or fixed fee arrangement in a 
personal injury or business litigation setting is a resort of confidence in our strategic 
judgments and the recognition that such arrangement are often the only way to make the civil 
justice system available to individuals and small businesses who otherwise could not afford to 
seek redress through the court.

We are available to speak with you 24 hours a day. Evening and weekend appointment are also 
available. If you are unable to come to one of our offices, our team member will meet whatever 
location is most convenient for you.

At legal experts India, we are proud to serve not only our clients but also the communities of our 
clients as well. We encourage and engage in many community events and charitable organisation. 
We believe in, and actively support many non-profit organisations that do wonderful work in these 
cities and communities. Why? Because the fine folks of these communities have given us the 
opportunity to be successful and it is very important to us to give back.</p> </div>


<div className="links-container">
          <div className="links-box">
            <h3>Important Websites Related To Government of India</h3>
            <ul>
              <li>
                <a
                  href="http://supremecourtofindia.nic.in/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  The Supreme Court, India
                </a>
              </li>
              <li>
                <a
                  href="http://india.gov.in/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  National Portal of India
                </a>
              </li>
              <li>
                <a
                  href="http://eci.nic.in/eci/eci.html/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Election Commission of India
                </a>
              </li>
              <li>
                <a
                  href="http://mha.nic.in/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Ministry of Home Affairs
                </a>
              </li>
              <li>
                <a
                  href="http://www.mea.gov.in/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Ministry of External Affairs
                </a>
              </li>
              <li>
                <a
                  href="http://boi.gov.in/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Bureau Of Immigration
                </a>
              </li>
              <li>
                <a
                  href="http://nhrc.nic.in/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  National Human Rights Commission
                </a>
              </li>
              <li>
                <a
                  href="http://passportindia.gov.in//"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Passport Services, India
                </a>
              </li>
              <li>
                <a
                  href="http://www.crpf.gov.in/default.aspx/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Central Reserve Police Force{" "}
                </a>
              </li>
              <li>
                <a
                  href="http://bsf.gov.in/SitePages/Home.aspx/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Border Security Force
                </a>
              </li>
              <li>
                <a
                  href="http://www.ssb.nic.in/index.aspx/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Sashastra Seema Bal
                </a>
              </li>
              <li>
                <a
                  href="http://itbpolice.nic.in/itbpwebsite/index.html/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Indo-Tibetan Border Police Force
                </a>
              </li>
            </ul>
          </div>

          <div className="links-box">
            <h3>Important Websites Related To Uttar Pradesh Govt.</h3>
            <ul>
              <li>
                <a
                  href="http://uplabour.gov.in/index.aspx/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Labour Departmentt, Government of Uttar Pradesh
                </a>
              </li>
              <li>
                <a
                  href="http://allahabadhighcourt.in/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Allahabad High Court
                </a>
              </li>
              <li>
                <a
                  href="http://ceouttarpradesh.nic.in/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Chief Electoral Officer, U.P.
                </a>
              </li>
              <li>
                <a
                  href="http://www.up.gov.in/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  UP Government Portal
                </a>
              </li>
              <li>
                <a
                  href="http://uppolice.gov.in/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  UP Police
                </a>
              </li>
              <li>
                <a
                  href="http://jansunwai.up.nic.in//"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Integrated Grievance Redressal System (IGRS), Government of
                  Uttar Pradesh{" "}
                </a>
              </li>
              <li>
                <a
                  href="http://www.uppbpb.gov.in/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  UP Police Recruitment Board
                </a>
              </li>
              <li>
                <a
                  href="http://uptourism.gov.in/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  UP Tourism
                </a>
              </li>
              <li>
                <a
                  href="http://uplegisassembly.gov.in/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  UP Legislative Assembly
                </a>
              </li>
            </ul>
          </div>
        </div>
  
  </div>;

  

  
  
}

export default About;

